export default () => ({
  generalAttributes: {
    display: 'flex',
    flexDirection: 'column',
  },
  subheading: {
    color: '#7C7C80',
    fontSize: '18px',
    fontWeight: '500',
    textTransform: 'uppercase',
    margin: '10px 0',
  },
  assigneeSection: {
    height: 130,
  },
  inputLabel: {
    width: 30,
  },
  input: {
    width: 50,
    marginRight: '10px',
  },
  icon: {
    opacity: 0.3,
    width: 30,
  },
  absentLockSpacing: {
    width: 30,
  },
  sectionRow: {
    display: 'flex',
    alignItems: 'center',
  },
  formLabel: {
    width: 90,
    color: 'rgba(0,0,0,1)',
    marginRight: 10,
  },
  select: {
    width: '80px',
  },
});
